import { useStore } from "@/store/authStore";
import axios from "axios";
import { useApiStore } from "@/store/apiStore";

export default function () {
  const store = useStore();
  const apiStore = useApiStore();
  /**
   * 与えられた画像ディレクトリから画像を取得し、Base64形式で返す関数。
   * @async
   * @param {string} imageDir - 取得する画像のディレクトリ。
   * @returns {Promise<string|null>} Base64形式の画像文字列。エラー時や画像が存在しない場合はnullを返す。
   * @throws {Error} 画像取得時にエラーが発生した場合。
   */
  const getImageFromUrl = async (imageDir) => {
    const validPattern = /^\/article\/\d{3}\/\d{3}\/\d{6}_\d\.jpg$/;
    const validVideoPattern = /^\/?video\/\d{3}\/\d{3}\/\d{6}\.jpg$/;
    if (!validPattern.test(imageDir) && !validVideoPattern.test(imageDir)) {
      return imageDir;
    }
    const apiUrlImage = apiStore.getImagePathForDir(imageDir);
    try {
      const tokenHeaders = store.getTokenHeaders;
      const extendedHeaders = {
        ...tokenHeaders,
        responseType: "arraybuffer",
      };
      const response = await axios.get(apiUrlImage, extendedHeaders);
      if (response.data) {
        // ArrayBufferをBase64文字列に変換
        let binary = "";
        const bytes = new Uint8Array(response.data);
        bytes.forEach((byte) => {
          binary += String.fromCharCode(byte);
        });
        const base64 = window.btoa(binary);
        const base64Image = `data:${response.headers["content-type"]};base64,${base64}`;
        return base64Image;
      }
    } catch (error) {
      console.error("画像の取得中にエラーが発生しました:", error);
    }
  };

  /**
   * 選択されたファイルを読み込み、読み込んだ結果を指定されたrefとストアに設定する。
   * @param {Event} event - ファイル入力イベントオブジェクト。
   * @param {Ref<string>} imageRef - 画像のデータを持つリアクティブなrefオブジェクト。
   * @returns {void}
   */
  const uploadFile = (event, imageRef) => {
    return new Promise((resolve, reject) => {
      if (!event.target.files.length) {
        // ファイルが選択されていない場合、関数を終了
        reject("ファイルが選択されていません。");
        return;
      }
      const file = event.target.files[0];
      if (!file.type.startsWith("image/")) {
        alert("ファイルは画像である必要があります。");
        reject("ファイルは画像である必要があります。");

        return;
      }

      // 300KB以上のファイルを制限する
      if (file.size > 307200) {
        // 300KB = 307,200バイト

        alert("ファイルは300KB未満である必要があります。");
        reject("ファイルは300KB未満である必要があります。");
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        imageRef.value = e.target.result;
        resolve(); // ファイルの読み込みが完了したらresolveを呼ぶ
      };
      reader.onerror = (e) => {
        reject(e); // エラーが発生した場合はrejectを呼ぶ
      };
      reader.readAsDataURL(file);
    });
  };
  // モジュールの公開関数を返す
  return {
    getImageFromUrl,
    uploadFile,
  };
}
